@if (customPricingList().length === 0) {
    <p class="empty">{{ 'packages.pricing.custom.empty' | translate }}</p>
}

<ul class="list">
    @for (group of customPricingList().controls; track group.controls.relatedEntityId; let i = $index) {
        <li class="item">
            <div class="meta">
                <span class="badge-type" [class.org]="group.controls.relatedEntityType.value === 'organisation'">
                    {{ 'packages.pricing.entity.' + group.controls.relatedEntityType.value | translate }}
                </span>
                <span class="name">{{ group.controls.relatedEntityId.value | entityLabel: pricingEntities() }}</span>
                <span class="count">
                    @if (group.controls.pricingList.length === 1) {
                        {{ 'packages.pricing.tierCount.one' | translate: { count: 1 } }}
                    } @else {
                        {{ 'packages.pricing.tierCount.other' | translate: { count: group.controls.pricingList.length } }}
                    }
                </span>
            </div>
            <div class="actions">
                <p-button
                    icon="pi pi-pencil"
                    [text]="true"
                    severity="secondary"
                    size="small"
                    type="button"
                    [ariaLabel]="'packages.pricing.custom.edit' | translate"
                    [attr.data-test]="testId() + '-row-edit-' + i"
                    (onClick)="editCustom.emit(i)"
                />
                <p-button
                    icon="pi pi-trash"
                    [text]="true"
                    severity="danger"
                    size="small"
                    type="button"
                    [ariaLabel]="'packages.pricing.custom.remove' | translate"
                    [attr.data-test]="testId() + '-row-remove-' + i"
                    (onClick)="removeCustom.emit(i)"
                />
            </div>
        </li>
    }
</ul>
